// PWA Service Worker Registration
(function() {
  'use strict';

  // Check if service workers are supported
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', function() {
      // Create service worker as blob to avoid CDN scope issues
      fetch('//vanlifeliving.co.uk/cdn/shop/t/16/assets/service-worker.js?v=114531713080874191031792480692')
        .then(function(response) {
          return response.text();
        })
        .then(function(swCode) {
          const blob = new Blob([swCode], { type: 'application/javascript' });
          const swUrl = URL.createObjectURL(blob);

          return navigator.serviceWorker.register(swUrl, {
            scope: '/'
          });
        })
        .then(function(registration) {
          console.log('Service Worker registered successfully:', registration.scope);

          // Check for updates periodically
          registration.addEventListener('updatefound', function() {
            const newWorker = registration.installing;
            newWorker.addEventListener('statechange', function() {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New service worker available, reload to update
                console.log('New content available, please refresh.');
                if (confirm('New version available! Reload to update?')) {
                  window.location.reload();
                }
              }
            });
          });
        })
        .catch(function(error) {
          console.log('Service Worker registration failed:', error);
        });
    });
  }

  // Handle iOS standalone mode
  let displayMode = 'browser';
  if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true) {
    displayMode = 'standalone';
    document.documentElement.classList.add('pwa-standalone');
  }

  // Add PWA install prompt
  let deferredPrompt;
  window.addEventListener('beforeinstallprompt', function(e) {
    // Prevent the mini-infobar from appearing
    e.preventDefault();
    // Stash the event so it can be triggered later
    deferredPrompt = e;

    // Dispatch custom event for theme to handle
    window.dispatchEvent(new CustomEvent('pwa-install-available'));
  });

  window.addEventListener('appinstalled', function() {
    console.log('PWA installed successfully');
    deferredPrompt = null;
  });

  // Expose install function globally
  window.installPWA = function() {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then(function(choiceResult) {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the install prompt');
        } else {
          console.log('User dismissed the install prompt');
        }
        deferredPrompt = null;
      });
    }
  };

  // Push notification functions
  window.PWA = window.PWA || {};

  // Request notification permission
  window.PWA.requestNotificationPermission = function() {
    if (!('Notification' in window)) {
      console.log('This browser does not support notifications');
      return Promise.reject('Notifications not supported');
    }

    if (Notification.permission === 'granted') {
      console.log('Notification permission already granted');
      return Promise.resolve('granted');
    }

    if (Notification.permission !== 'denied') {
      return Notification.requestPermission().then(function(permission) {
        console.log('Notification permission:', permission);
        return permission;
      });
    }

    return Promise.reject('Notification permission denied');
  };

  // Check if notifications are supported and enabled
  window.PWA.areNotificationsEnabled = function() {
    return ('Notification' in window) && Notification.permission === 'granted';
  };

  // Get push subscription
  window.PWA.getPushSubscription = function() {
    if (!('serviceWorker' in navigator)) {
      return Promise.reject('Service workers not supported');
    }

    return navigator.serviceWorker.ready.then(function(registration) {
      return registration.pushManager.getSubscription();
    });
  };

  // Subscribe to push notifications
  window.PWA.subscribeToPush = function() {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
      return Promise.reject('Push notifications not supported');
    }

    return navigator.serviceWorker.ready.then(function(registration) {
      return registration.pushManager.subscribe({
        userVisibleOnly: true,
        // You would need to generate VAPID keys for production use
        // applicationServerKey: urlBase64ToUint8Array('YOUR_PUBLIC_VAPID_KEY')
      }).then(function(subscription) {
        console.log('Push subscription created:', subscription);
        // Send subscription to your server here
        return subscription;
      });
    });
  };

  // Unsubscribe from push notifications
  window.PWA.unsubscribeFromPush = function() {
    return window.PWA.getPushSubscription().then(function(subscription) {
      if (subscription) {
        return subscription.unsubscribe().then(function(successful) {
          console.log('Unsubscribed from push:', successful);
          return successful;
        });
      }
      return false;
    });
  };

  // Show a test notification (for testing purposes)
  window.PWA.showTestNotification = function(title, options) {
    if (!window.PWA.areNotificationsEnabled()) {
      return window.PWA.requestNotificationPermission().then(function() {
        return window.PWA.showTestNotification(title, options);
      });
    }

    const defaultOptions = {
      body: 'This is a test notification from ',
      icon: '//vanlifeliving.co.uk/cdn/shop/files/Fav_2.png?height=192&v=1787312336&width=192',
      badge: '//vanlifeliving.co.uk/cdn/shop/files/Fav_2.png?height=96&v=1787312336&width=96',
      vibrate: [200, 100, 200],
      data: { url: '' }
    };

    const notificationOptions = Object.assign({}, defaultOptions, options || {});

    return navigator.serviceWorker.ready.then(function(registration) {
      return registration.showNotification(
        title || '',
        notificationOptions
      );
    });
  };

  console.log('PWA utilities loaded. Available commands:');
  console.log('- window.installPWA() - Show install prompt');
  console.log('- window.PWA.requestNotificationPermission() - Request notification permission');
  console.log('- window.PWA.showTestNotification("Title", {body: "Message"}) - Show test notification');
  console.log('- window.PWA.subscribeToPush() - Subscribe to push notifications');
})();
